module.exports = __webpack_public_path__ + "VIPG8.png?e18e0821049e836f9fa5d0ad0a5e6fb8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/greyhounds/VIPG8.png
// module id = 80
// module chunks = 0